<template>
	<Modal
		:show="showGroupScheme"
		content_class="col-12 col-md-7 col-lg-6 col-xl-5 view-scheme"
	>
		<template slot="content">
			<div>
				<div class="clearfix top">
					<div class="left-content f-l">
						<div class="content-title">View Group Schemes</div>
						<div class="subtitle" v-if="selected_scheme">
							{{ selected_scheme.scheme_name }} Group Membership
						</div>
					</div>
					<div
						class="close-modal f-r"
						@click="$store.commit('showGroupScheme', false)"
					>
						<i class="fa fa-times"></i>
					</div>
				</div>

				<div
					class="scheme"
					v-for="(scheme, i) in group_schemes"
					:key="i"
				>
					<div
						class="card card-details"
						@click="viewSchemeDetails(scheme)"
						v-if="scheme.group_details"
					>
						<div class="clearfix">
							<div
								class="status"
								v-if="scheme.scheme_member_status"
								:class="{
									green:
										scheme.scheme_member_status ===
										'ACTIVE',
								}"
							>
								{{
									scheme.scheme_member_status
										.split(':')
										.join(' ')
								}}
							</div>
							<div class="ref">
								{{
									scheme.group_details.system_scheme_group_ref
								}}
							</div>
							<div class="blue">
								{{ scheme.group_details.scheme_group_type }}
							</div>
							<div class="name">
								Added on:
								<b>{{
									moment(scheme.created_date).format(
										'Do MMM YYYY HH:mm',
									)
								}}</b>
							</div>
							<div class="name">
								{{ scheme.group_details.scheme_group_name }}
							</div>
							<div class="name">
								{{
									scheme.group_details
										.scheme_group_description
								}}
							</div>
							<div class="btn-bottom">
								<i class="fa fa-eye"></i>
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import profile from '../rsc/stores/profile.store';

export default {
	beforeCreate() {
		Event.$emit('loader:show', true);
	},
	beforeDestroy() {
		this.$store.unregisterModule('profile');
	},
	created() {
		utils.registerModule('profile', profile, this.$store);
	},
	components: {
		Modal: () => import('../templates/others/modal'),
		Form: () => import('@/libs/clarks/components/form'),
	},
	data() {
		return {
			moment,
			utils,
			api,
		};
	},
	computed: {
		...mapGetters(['showGroupScheme', 'group_schemes', 'selected_scheme']),
	},
	methods: {
		...mapActions(['viewSchemeDetails']),
	},
	async mounted() {
		utils.registerModule('profile', profile, this.$store);
	},
};
</script>

<style lang="less">
@grey: #a7abbd;

.view-scheme {
}
</style>
